<div class="title">
    <span>{{'instruction' | translate }}</span>
</div>
<div class="actions">
    <button mat-menu-item (click)="download.emit()">
        <mat-icon svgIcon="files"></mat-icon>
        <span> {{ 'download' | translate}}</span>
    </button>
</div>
